import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { NgxCurrencyDirective } from 'ngx-currency';
import { ServicoTomadoLookupService } from '../../../../../shared/services/apis/repo-dfse/servico-tomado-lookup.service';
import { LookupItem } from '@shared/services/responses/repo-dfse/lookup-list.response';

@Component({
  selector: 'app-servico-tomado-servicos',
  standalone: true,
  imports: [ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatIconModule, NgxCurrencyDirective],
  templateUrl: './servico-tomado-servicos.component.html',
})
export class ServicoTomadoServicosComponent implements OnInit {
  @Input({ required: true }) form!: FormGroup;
  @Input() dynamicCurrencyMask: any;

  public naturezaOpcoes: LookupItem[] = [];
  public origemCreditoOpcoes: LookupItem[] = [];

  constructor(private lookupService: ServicoTomadoLookupService) { }

  ngOnInit(): void {
    this.lookupService.getNaturezaBaseCalculoCredito().subscribe(response => this.naturezaOpcoes = response.list);
    this.lookupService.getOrigemCredito().subscribe(response => this.origemCreditoOpcoes = response.list);
  }
}
